import IAuthService from "./IAuthService";
import { inject, injectable } from "inversify";
import { BaseLoginModel } from "../../models/auth/BaseLoginModel";
import { AuthApi } from "../api/AuthApi";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { DiTokens } from "../diTokens";
import i18n from "@/i18n";
import ISessionService from "./ISessionService";
import storeAccessor from "../../store/storeAccessor";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import { MessageTypeEnum } from "../../models/enums/MessageTypeEnum";
import { AuthStore } from "../../store/modules/auth";

@injectable()
/**Сервис авторизации клиента (по логину и паролю)*/
export default class BaseAuthService implements IAuthService<BaseLoginModel> {
  constructor(
  @inject(DiTokens.SessionService) private sessionService: ISessionService
  ) { }

   /**Инициализация данных авторизации */
  public async init(params: any): Promise<BaseLoginModel> {
    const model: BaseLoginModel = new BaseLoginModel();

    if(this.configStore.passwordRequirements.isEmpty()) {
      await this.configStore.fetchPasswordRequirements();
    }
    model.PasswordRequirements = this.configStore.passwordRequirements;
    model.Login = this.authStore.login;
    model.ActionStateText = this.authStore.msg;
    this.authStore.setLogin("");
    this.authStore.setMsg("");
    
    return model;
  }

  /**
   * Вход
   * @param loginModel Модель авторизации
   * @returns Модель авторизации
   */
  public async login(loginModel: BaseLoginModel): Promise<BaseLoginModel> {
    try {
      await AuthApi.loginAsync(loginModel);
      loginModel._actionState = ActionStateEnum.Success;
      await this.sessionService.setSession(loginModel.Login);
    } catch (e) {
      loginModel.ActionStateText = e.message;

      if (e.message === "Попытка доступа с одноразовым паролем!") {
        loginModel._isChangePassword = true;
        loginModel.ActionStateText = i18n.t("auth.messages.oneTimePassword").toString();
        loginModel.MsgType = MessageTypeEnum.Warning;
      } else if (e.message === "Попытка доступа с устаревшим паролем!") {
        loginModel._isChangePassword = true;
        loginModel.ActionStateText = i18n.t("auth.messages.outdatedPassword").toString();
        loginModel.MsgType = MessageTypeEnum.Warning;
      } else if (e.message === "Действует двухфакторная авторизация!") {
        loginModel._actionState = ActionStateEnum.Confirm;
        loginModel.ActionStateText = i18n.t("auth.messages.confrimSmsCode").toString();
        loginModel._isNeedConfirm = true;
        loginModel.MsgType = MessageTypeEnum.Info;
      } else {
        throw e;
      }
    }
    return loginModel;
  }

  /**Выход из системы */
  public async logout(): Promise<void> {
    await this.sessionService.logoutSession(true);
  }

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, storeAccessor.store);
  }

  /**Стор авторизации */
  get authStore(): AuthStore {
    return getModule(AuthStore, storeAccessor.store);
  }
}
